module.exports = __webpack_public_path__ + "img/knees.9ec0d97b.png";